import React, { useEffect } from 'react';
import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Footer from './pages/Footer';
import { msalInstance } from './services/authInstance';

function App() {



  useEffect(() => {
    const onStorageChange = (event: StorageEvent) => {
      if (event.key === "logout-event") {
        // Passive tabs: just go to login page.
        // Do NOT call msalInstance.logoutRedirect here, or they’ll all hit Azure’s sign-out screen.
        window.location.replace("/login"); // or "/"
      }
    };

    window.addEventListener("storage", onStorageChange);
    return () => window.removeEventListener("storage", onStorageChange);
  }, []);



  useEffect(() => {
    let idleTimer: NodeJS.Timeout;

    const resetTimer = () => {
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        const currentAccount = msalInstance.getActiveAccount();
        if (currentAccount) {
          // Trigger logout in this tab
          msalInstance.logoutRedirect();

          // ✅ Notify other tabs
          localStorage.setItem("logout-event", Date.now().toString());
        }
      }, 30 * 60 * 1000); // 30 minutes
    };

    const events = ["mousemove", "keydown", "scroll", "touchstart"];
    events.forEach(e => window.addEventListener(e, resetTimer));

    resetTimer();

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      if (idleTimer) clearTimeout(idleTimer);
    };
  }, []);


  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        {/* Main content area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </main>

        {/* Footer always at bottom */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
